import React, { useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import Grid from "@mui/material/Grid";
import logo from "./../../../assets/images/logo.png";
import { useTheme, Button, IconButton } from "@mui/material";
import "./home-navbar.css";
import { GrFormClose } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
let HomeNavbar = () => {
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currenctPage, setCurrentPage] = useState("Home");
  console.log("currenctPage", currenctPage);
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("lg"));
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };
  return (
    <>
      {isMatch ? (
        <div>
          <Grid container>
            <Grid item xs={12}>
              <div className="main-appbar-container">
                <div className="main-appbar-content-wraper">
                  <Button variant="text">
                    <img src={logo} alt="logo" />
                  </Button>
                  <MenuIcon
                    className="app-bar-component-menu-icon"
                    onClick={() => {
                      setIsDrawerOpen(true);
                    }}
                  />
                </div>
              </div>
            </Grid>
          </Grid>

          <Drawer anchor="left" open={isDrawerOpen} onClose={handleDrawerClose}>
            <div>
              <div className="app-bar-component-drawer-header-container">
                <IconButton
                  className="app-bar-component-drawer-close-btn"
                  onClick={() => {
                    setIsDrawerOpen(false);
                  }}
                >
                  <GrFormClose />
                </IconButton>
              </div>
              <div className="app-bar-component-drawer-nav-links-container">
                <a
                  href="#home-section"
                  onClick={() => {
                    setCurrentPage("Home");
                    setIsDrawerOpen(false);
                  }}
                  className={
                    currenctPage === "Home"
                      ? "home-navbar-active-link"
                      : "home-navbar-un-active-link"
                  }
                >
                  Home
                </a>

                <a
                  href="#courses-section"
                  onClick={() => {
                    setCurrentPage("Courses");
                    setIsDrawerOpen(false);
                  }}
                  className={
                    currenctPage === "Courses"
                      ? "home-navbar-active-link"
                      : "home-navbar-un-active-link"
                  }
                >
                  courses
                </a>
                <a
                  href="#tutors-section"
                  onClick={() => {
                    setCurrentPage("Tutors");
                    setIsDrawerOpen(false);
                  }}
                  className={
                    currenctPage === "Tutors"
                      ? "home-navbar-active-link"
                      : "home-navbar-un-active-link"
                  }
                >
                  tutors
                </a>

                <a
                  href="#about-us-section"
                  onClick={() => {
                    setCurrentPage("AboutUs");
                    setIsDrawerOpen(false);
                  }}
                  className={
                    currenctPage === "AboutUs"
                      ? "home-navbar-active-link"
                      : "home-navbar-un-active-link"
                  }
                >
                  about us
                </a>
                <a
                  href="#testimonial-section"
                  onClick={() => {
                    setCurrentPage("Testimonial");
                    setIsDrawerOpen(false);
                  }}
                  className={
                    currenctPage === "Testimonial"
                      ? "home-navbar-active-link"
                      : "home-navbar-un-active-link"
                  }
                >
                  testimonial
                </a>
                <a
                  href="#events-section"
                  onClick={() => {
                    setCurrentPage("Events");
                    setIsDrawerOpen(false);
                  }}
                  className={
                    currenctPage === "Events"
                      ? "home-navbar-active-link"
                      : "home-navbar-un-active-link"
                  }
                >
                  events
                </a>
                <a
                  href="#letest-updates-section"
                  onClick={() => {
                    setCurrentPage("LetestUpdates");
                    setIsDrawerOpen(false);
                  }}
                  className={
                    currenctPage === "LetestUpdates"
                      ? "home-navbar-active-link"
                      : "home-navbar-un-active-link"
                  }
                >
                  letest updates
                </a>
                <Button
                  className="home-navbar-button"
                  variant="text"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  login
                </Button>
                <Button
                  className="home-navbar-button"
                  variant="text"
                  onClick={() => {
                    navigate("/register");
                  }}
                >
                  register
                </Button>
              </div>
            </div>
          </Drawer>
        </div>
      ) : (
        <div>
          <Grid container>
            <Grid item xs={12}>
              <div className="main-appbar-container">
                <div className="main-appbar-content-wraper">
                  <Button variant="text">
                    <img src={logo} alt="logo" />
                  </Button>
                  <div className="nav-links">
                    <a
                      href="#home-section"
                      onClick={() => setCurrentPage("Home")}
                      className={
                        currenctPage === "Home"
                          ? "home-navbar-mobile-view-active-link"
                          : "home-navbar-mobile-view-un-active-link"
                      }
                    >
                      Home
                    </a>
                    <a
                      href="#courses-section"
                      onClick={() => setCurrentPage("Courses")}
                      className={
                        currenctPage === "Courses"
                          ? "home-navbar-mobile-view-active-link"
                          : "home-navbar-mobile-view-un-active-link"
                      }
                    >
                      courses
                    </a>
                    <a
                      href="#tutors-section"
                      onClick={() => setCurrentPage("Tutors")}
                      className={
                        currenctPage === "Tutors"
                          ? "home-navbar-mobile-view-active-link"
                          : "home-navbar-mobile-view-un-active-link"
                      }
                    >
                      tutors
                    </a>
                    <a
                      href="#about-us-section"
                      onClick={() => setCurrentPage("AboutUs")}
                      className={
                        currenctPage === "AboutUs"
                          ? "home-navbar-mobile-view-active-link"
                          : "home-navbar-mobile-view-un-active-link"
                      }
                    >
                      about us
                    </a>
                    <a
                      href="#testimonial-section"
                      onClick={() => setCurrentPage("Testimonial")}
                      className={
                        currenctPage === "Testimonial"
                          ? "home-navbar-mobile-view-active-link"
                          : "home-navbar-mobile-view-un-active-link"
                      }
                    >
                      testimonial
                    </a>
                    <a
                      href="#events-section"
                      onClick={() => setCurrentPage("Events")}
                      className={
                        currenctPage === "Events"
                          ? "home-navbar-mobile-view-active-link"
                          : "home-navbar-mobile-view-un-active-link"
                      }
                    >
                      events
                    </a>
                    <a
                      href="#letest-updates-section"
                      onClick={() => setCurrentPage("LetestUpdates")}
                      className={
                        currenctPage === "LetestUpdates"
                          ? "home-navbar-mobile-view-active-link"
                          : "home-navbar-mobile-view-un-active-link"
                      }
                    >
                      letest updates
                    </a>
                  </div>
                  <div>
                    <Button
                      variant="text"
                      className="sign-up-btn"
                      onClick={() => {
                        navigate("/login");
                      }}
                    >
                      login
                    </Button>
                    <Button
                      className="sign-up-btn"
                      variant="text"
                      onClick={() => {
                        navigate("/register");
                      }}
                    >
                      register
                    </Button>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
};

export default HomeNavbar;
